import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ToastService } from '../_core/services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptor implements HttpInterceptor {
  private readonly toastService = inject(ToastService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (environment.showErrorInfo && error.status !== 404 && error.status !== 401 && error.status !== 429 && !error.url.includes('/invitations/forward') && !error.url.includes('caf-data')) {
          const errorInfo = error.error && error.error.errorCode;
          this.toastService.showToast(`${error.status} ${errorInfo || ''} | ${error.statusText} | ${error.url}`, 'warning');
        }

        return throwError(error);
      })
    );
  }
}
